import {hasUserProfilingConsent} from '../services/privacyService';
import {getFromCookie} from './storage';

export type GigyaModes = 'premium' | 'freemium' | 'dpg_mm';

declare global {
	interface Window {
		dataLayer?: Array<unknown>;
	}
}

export function getGigyaId(mode: GigyaModes): string | false | null {
	if (!hasUserProfilingConsent()) {
		return null;
	}

	switch (mode) {
		case 'dpg_mm':
			return _sanomaModule();

		case 'freemium':
			return _freemium();

		case 'premium': {
			return _premium();
		}
	}
}

function _sanomaModule() {
	const gigyaid = getFromCookie('SA_UID');

	if (gigyaid) {
		return gigyaid;
	}

	return false;
}

function _freemium() {
	// @ts-ignore
	const dl = window.dataLayer?.find(l => l.user?.account_id);

	if (dl) {
		// @ts-ignore
		return dl.user.account_id;
	}

	return false;
}

function _premium() {
	const dl = window.dataLayer?.find(l => l['gigya-id']);

	if (dl) {
		return dl['gigya-id'];
	}

	return false;
}
